export default "__VITE_ASSET__NVvTzj4h__"